import React from "react";
import {RouteComponentProps} from "react-router";

interface LocaleContextData {
    locale: string;
    setLocale: (locale: string) => void;
}

export const LocaleContext = React.createContext({
    locale: process.env.REACT_APP_DEFAULT_LOCALE || '',
    setLocale: (locale: string) => {}
});

interface Props {
    locale: string;
}

export default class LocaleProvider extends React.Component<Props & RouteComponentProps, LocaleContextData> {

    componentDidUpdate(prevProps: Readonly<Props & RouteComponentProps>) {
        if (this.props.locale !== prevProps.locale) {
            this.setState({locale: this.props.locale});
        }
    }

    setLocale = (locale: string) => {
        if (locale !== this.state.locale) {
            this.props.history.push(
                this.props.location.pathname.replace(
                    this.state.locale,
                    locale
                )
            );
        }
    };

    state: LocaleContextData = {
        locale: this.props.locale,
        setLocale: this.setLocale,
    };

    render(): JSX.Element {
        return (
            <LocaleContext.Provider value={this.state}>
                {this.props.children}
            </LocaleContext.Provider>
        );
    }
}